export default {"src":"/_next/static/media/security-fill.a1cc75d3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};